import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Main } from '../../../../../constant';
import { Input } from '../../../../../components/input/input';
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Grid, Stack, Typography, Select, MenuItem, FormControl, InputLabel, Avatar } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginauth } from '../../../../../redux/actions/loginauth';
import { ShowLoader } from '../../../../../redux/actions/loader';

const Auth = (props) => {
    const [data, setData] = useState(Main().otp);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [schoolLogo, setSchoolLogo] = useState('');
    const dispatch = useDispatch();
    const apilink = useSelector((state) => state.Api.apiLink);
    const allSchools = useSelector((state) => state.Api.allSchools);
    const veri = useSelector((state) => state.Auth.permission);
    const navigate = useNavigate();

    const initialInputValues = Object.fromEntries(
        data.inputs.map((item) => [item.name, ''])
    );

    const [inputValues, setInputValues] = useState(initialInputValues);

    // Load saved school on component mount
    useEffect(() => {
        const savedSchool = localStorage.getItem('selectedSchool');
        if (savedSchool) {
            const school = JSON.parse(savedSchool);
            setSelectedSchool(school);
            loadSchoolLogo(school);
        } else if (allSchools && allSchools.length > 0) {
            setSelectedSchool(allSchools[0]);
            loadSchoolLogo(allSchools[0]);
        }
    }, [allSchools]);

    const loadSchoolLogo = (school) => {
        if (school && school.backend && school.WebSrn) {
            const logoUrl = `${school.backend}/Public/${school.WebSrn}/${school.WebSrn}.png`;
            // console.log(logoUrl)
            setSchoolLogo(logoUrl);
            console.log('Loading logo from:', logoUrl);
        }
    };

    const handleSchoolChange = (event) => {
        const school = event.target.value;
        setSelectedSchool(school);
        loadSchoolLogo(school);
        
        // Save to localStorage
        localStorage.setItem('selectedSchool', JSON.stringify(school));
        
        // Update the API link in localStorage
        if (school.mobile) {
            localStorage.setItem('server', school.mobile);
        }
        
        // You might want to dispatch an action to update Redux state
        // dispatch(updateApiConfig(school));
    };

    function handleInputChange(e) {
        setInputValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.value,
        }));
    }

    function myfunc(event) {
        dispatch(ShowLoader('1'));
        event.preventDefault();
        
        localStorage.setItem("otp", inputValues.Otp);
        localStorage.setItem("mobileNumber", inputValues.Mobile);
        
        // Use the selected school's API link or the current apilink
        const currentApiLink = selectedSchool ? selectedSchool.mobile : apilink;
        localStorage.setItem("server", currentApiLink);
        
        const userdata = { Otp: inputValues.Otp, Mobile: inputValues.Mobile };
        const payload = { ...userdata, api: currentApiLink };

        dispatch(loginauth(inputValues, currentApiLink));
    }

    return (
        <form onSubmit={myfunc}>
            <Stack spacing={2}>

                {/* School Logo Display */}
                {schoolLogo && (
                    <Grid item lg={12}>
                        <Box display="flex" justifyContent="center" mt={2}>
                            <Avatar 
                                src={schoolLogo}
                                alt={selectedSchool?.name}
                                sx={{ width: 100, height: 100 }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = 'fallback-image-url.png';
                                }}
                            />
                        </Box>
                    </Grid>
                )}



                {/* School Dropdown */}
                <Grid item lg={12}>
                    <Box>
                        <Typography variant="subtitle1" fontWeight={600} component="label" >
                            Select School
                        </Typography>
                        <FormControl fullWidth>
                            <Select
                                value={selectedSchool || ''}
                                onChange={handleSchoolChange}
                                displayEmpty
                                renderValue={(selected) => {
                                    if (!selected) {
                                        return <em>Select a school</em>;
                                    }
                                    return selected.name;
                                }}
                            >
                                {allSchools && allSchools.map((school, index) => (
                                    <MenuItem key={index} value={school}>
                                        <Stack direction="row" alignItems="center" spacing={2}>
                                            <Avatar 
                                                src={`${school.backend}/${school.WebSrn}.png`}
                                                alt={school.name}
                                                sx={{ width: 30, height: 30 }}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = 'fallback-image-url.png'; // Add a fallback image
                                                }}
                                            />
                                            <Typography>{school.name}</Typography>
                                        </Stack>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>

                
                {/* Input Fields */}
                {data.inputs.map((item, ind) => (
                    <Grid item lg={12} key={ind}>
                        <Box>
                            <Typography variant="subtitle1"
                                fontWeight={600} component="label" htmlFor='password' mb="5px">
                                {item.label}
                            </Typography>
                            <Input
                                key={ind}
                                type={item.type}
                                placeholder={item.data}
                                required={item.required}
                                name={item.name}
                                onChange={(event) => handleInputChange(event)}
                            />
                        </Box>
                    </Grid>
                ))}

                <Box>
                    <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        fullWidth
                        sx={{ marginTop: '10px' }}
                        type="submit"
                    >
                        {data.butn}
                    </Button>
                </Box>
            </Stack>
        </form>
    );
};

Auth.propTypes = {};

export default Auth;